import { memo, PropsWithChildren, Suspense } from 'react';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';

const AppSuspense: React.FC<PropsWithChildren> = ({ children }): JSX.Element => {
  return <Suspense fallback={<LoadingSpinner bgColor="transparent" />}>{children}</Suspense>;
};

export default memo(AppSuspense);
